import ComponentsFactory from 'foundation/components-factory';
import WeglotComponent from './js/weglot.component';

ComponentsFactory.getInstance().define('weglot', WeglotComponent);
